export default __webpack_public_path__ + "static/tree-cameraRaw-hu-h348-787adf5eb5343c57afc073ddd26c64fc.png";